(() => {
  const win = /** @type {any} */ (window);

  if (!customElements.get('banner-slice')) {
    class BannerSlice extends HTMLElement {
      constructor() {
        super();

        this.input = /** @type {HTMLInputElement | null} */ (this.querySelector('[data-slice-input]'));
        this.overlay = /** @type {HTMLElement | null} */ (this.querySelector('[data-slice-overlay]'));
        this.line = /** @type {HTMLElement | null} */ (this.querySelector('[data-slice-line]'));
        this.handle = /** @type {HTMLElement | null} */ (this.querySelector('[data-slice-handle]'));

        this.sync = this.sync.bind(this);
      }

      connectedCallback() {
        if (!this.input) return;
        this.input.addEventListener('input', this.sync);
        this.input.addEventListener('pointerdown', this.stopPropagation);
        this.input.addEventListener('touchstart', this.stopPropagation, { passive: true });
        this.sync();
      }

      disconnectedCallback() {
        if (!this.input) return;
        this.input.removeEventListener('input', this.sync);
        this.input.removeEventListener('pointerdown', this.stopPropagation);
        this.input.removeEventListener('touchstart', this.stopPropagation);
      }

      /** @param {Event} event */
      stopPropagation(event) {
        event.stopPropagation();
      }

      sync() {
        if (!this.input) return;

        const value = Number(this.input.value || '50');
        const position = Math.min(100, Math.max(0, value));
        const percent = `${position}%`;

        this.style.setProperty('--comparison-position', String(position));
        if (this.line) this.line.style.left = percent;
        if (this.handle) this.handle.style.left = percent;
      }
    }

    customElements.define('banner-slice', BannerSlice);
  }

  /** @param {HTMLElement} root */
  function initIndicators(root) {
    const carousel = /** @type {HTMLElement | null} */ (root.querySelector('[data-comparison-carousel]'));
    const indicatorWrap = /** @type {HTMLElement | null} */ (root.querySelector('[data-comparison-indicators]'));
    if (!carousel || !indicatorWrap) return;

    const indicators = /** @type {HTMLButtonElement[]} */ (Array.from(indicatorWrap.querySelectorAll('[data-slide-index]')));
    const slides = /** @type {HTMLElement[]} */ (Array.from(carousel.querySelectorAll('.f-carousel__slide')));
    if (!indicators.length || !slides.length) return;

    /** @param {number} index */
    const setActive = (index) => {
      indicators.forEach((button) => {
        const isActive = Number(button.dataset.slideIndex) === index;
        button.classList.toggle('is-active', isActive);
      });
    };

    const getActiveSlideIndex = () => {
      const selected = /** @type {HTMLElement | null} */ (carousel.querySelector('.f-carousel__slide.is-selected, .f-carousel__slide[aria-hidden="false"]'));
      if (!selected) return 0;
      const index = slides.indexOf(selected);
      return index >= 0 ? index : 0;
    };

    /** @param {number} index */
    const goTo = (index) => {
      const carouselApi = (win.Carousel && typeof win.Carousel.getInstance === 'function')
        ? win.Carousel.getInstance(carousel)
        : null;

      if (!carouselApi) {
        const currentIndex = getActiveSlideIndex();
        const direction = index > currentIndex ? 'next' : 'prev';
        const clicks = Math.abs(index - currentIndex);
        const button = /** @type {HTMLButtonElement | null} */ (carousel.querySelector(`.f-carousel__nav .f-button.is-${direction}`));
        if (!button) return;
        for (let i = 0; i < clicks; i += 1) button.click();
        return;
      }

      if (typeof carouselApi.slideTo === 'function') {
        carouselApi.slideTo(index);
        return;
      }
      if (typeof carouselApi.to === 'function') {
        carouselApi.to(index);
        return;
      }
      if (typeof carouselApi.setPage === 'function') {
        carouselApi.setPage(index);
      }
    };

    indicators.forEach((button) => {
      button.addEventListener('click', () => {
        const index = Number(button.dataset.slideIndex || '0');
        goTo(index);
      });
    });

    const observer = new MutationObserver(() => {
      setActive(getActiveSlideIndex());
    });

    slides.forEach((slide) => {
      observer.observe(slide, { attributes: true, attributeFilter: ['class', 'aria-hidden'] });
    });

    setActive(getActiveSlideIndex());
  }

  function init() {
    const sections = /** @type {HTMLElement[]} */ (Array.from(document.querySelectorAll('.madesa-projetos-page-comparison [data-comparison-root]')));
    sections.forEach(initIndicators);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
